import GetStartedScreen from "@/features/get-started/GetStartedScreen";

export default GetStartedScreen;
